var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "reveal-kg-workspace" },
    [
      _c(
        "header",
        { staticClass: "rkw-header" },
        [
          _c("div", { staticClass: "rkw-brand" }, [
            _c("span", { staticClass: "rkw-mark" }, [_vm._v("REVEAL")]),
            _c("span", { staticClass: "rkw-title" }, [_vm._v("KG Canvas")]),
            _vm.interactiveModelLabel
              ? _c("span", { staticClass: "rkw-model-badge" }, [
                  _vm._v(" " + _vm._s(_vm.interactiveModelLabel) + " "),
                ])
              : _vm._e(),
          ]),
          _c("WorkspaceMenuBar", { on: { action: _vm.onMenuAction } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "rkw-stage" },
        [
          _vm.analysisBubblesVisible
            ? _c(
                "div",
                { staticClass: "rkw-analysis-bubbles" },
                [
                  _c("WorkspaceDatasetsBubble", {
                    attrs: {
                      visible: _vm.datasetsBubbleVisible,
                      entries: _vm.savedDatasetRuns,
                    },
                    on: { "open-datasets": _vm.openSavedDatasetsRun },
                  }),
                  _c("WorkspaceHypothesesBubble", {
                    attrs: {
                      visible: _vm.hypothesesBubbleVisible,
                      entries: _vm.savedHypothesisRuns,
                    },
                    on: { "open-hypotheses": _vm.openSavedHypothesesRun },
                  }),
                  _c("WorkspaceExplanationBubble", {
                    attrs: {
                      visible: _vm.explanationBubbleVisible,
                      entries: _vm.savedGraphExplanations,
                    },
                    on: { "open-explanation": _vm.openSavedExplanation },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "rkw-canvas-shell" },
            [
              _c("WorkspaceCanvas", {
                ref: "workspaceCanvas",
                attrs: {
                  "graph-nodes": _vm.canvasGraphNodes,
                  "all-graph-nodes": _vm.allCanvasGraphNodes,
                  "ledger-session": _vm.activeSession,
                  "graph-edges": _vm.canvasGraphEdges,
                  "contextual-edges": _vm.canvasContextualEdges,
                  "graph-loading": _vm.graphLoading,
                  "graph-busy": _vm.canvasGraphBusy,
                  "graph-error": _vm.graphError,
                  "selected-node-id": _vm.selectedNodeId,
                  "selected-edge-id": _vm.selectedEdgeId,
                  "key-node-ids": _vm.canvasKeyNodeIds,
                  "node-ids-with-evidence": _vm.nodeIdsWithEvidence,
                  "edge-keys-with-evidence": _vm.edgeKeysWithEvidence,
                  "selected-node-detail": _vm.selectedNodeDetail,
                  "selected-edge-detail": _vm.selectedEdgeDetail,
                  "gene-inspector-context": _vm.geneInspectorContext,
                  "trait-inspector-context": _vm.traitInspectorContext,
                  "mechanism-inspector-context": _vm.mechanismInspectorContext,
                  "gene-set-inspector-context": _vm.geneSetInspectorContext,
                  "expression-options": _vm.expressionOptions,
                  "api-client": _vm.apiClient,
                  "inspector-open": _vm.inspectorOpen,
                  "retrieval-ledger": _vm.canvasRetrievalLedger,
                  "table-add-busy": _vm.tableAddBusy,
                  "inspector-content-key": _vm.inspectorContentKey,
                  "graph-reminder": _vm.graphReminder,
                  "ai-assistant-open": _vm.aiAssistantOpen,
                  "canvas-active": Boolean(_vm.activeSession),
                },
                on: {
                  "node-menu-open": _vm.onNodeMenuOpen,
                  "edge-menu-open": _vm.onEdgeMenuOpen,
                  "toggle-inspector": _vm.onToggleInspector,
                  "close-inspector": function ($event) {
                    _vm.inspectorOpen = false
                  },
                  "graph-action": _vm.onGraphAction,
                  "add-table-node": _vm.onAddTableNode,
                  "remove-table-node": _vm.onRemoveTableNode,
                  "cache-node-connections": _vm.onCacheNodeConnections,
                  "cache-node-expression": _vm.onCacheNodeExpression,
                  "cache-factor-loadings": _vm.onCacheFactorLoadings,
                  "load-factor-loadings": _vm.onLoadFactorLoadings,
                  "inspect-connected-edge": _vm.onEdgeActionInspect,
                  "inspect-connected-node": _vm.onNodeActionInspect,
                  "graph-reminder-action": _vm.onGraphReminderAction,
                  "graph-reminder-dismiss": _vm.dismissGraphReminder,
                },
              }),
              _c("WorkspaceExpandProgressOverlay", {
                attrs: {
                  open: _vm.expandGraphLoading,
                  message: _vm.expandGraphProgress,
                  progress: _vm.expandBatchProgress,
                },
              }),
              _c("WorkspaceAssistantActionProgressOverlay", {
                attrs: {
                  open: _vm.assistantActionProgressOpen,
                  message: _vm.assistantActionProgressMessage,
                },
              }),
            ],
            1
          ),
          _c("WorkspaceExpandGraphPanel", {
            attrs: {
              open: _vm.expandGraphOpen,
              "initial-tab": _vm.expandPanelInitialTab,
              loading: _vm.expandGraphLoading,
              "manual-add-busy": _vm.expandManualAddBusy,
              "intent-add-busy": _vm.expandIntentAddBusy,
              "intent-add-status": _vm.expandIntentAddStatus,
              "intent-add-explanation": _vm.expandIntentAddExplanation,
              filters: _vm.expandFilters,
              controls: _vm.expandControls,
              "expand-seed-summary": _vm.expandSeedSummary,
              "expand-seed-label": _vm.expandSeedLabel,
              "expand-from-single-node": _vm.expandFromSingleNode,
              "expand-from-edge": _vm.expandFromEdge,
              "expansion-history-entries": _vm.expansionHistoryEntries,
              "available-target-types": _vm.expandAvailableTargetTypes,
              "expression-options": _vm.expressionOptions,
              "api-client": _vm.apiClient,
              "llm-available": _vm.llmAvailable,
              "gene-set-semantic-search-available":
                _vm.geneSetSemanticSearchAvailable,
              "expand-trait-gene-set-mode": _vm.expandTraitGeneSetMode,
              "expand-seed-are-all-traits": _vm.expandSeedAreAllTraits,
              "graph-node-ids": _vm.graphNodeIds,
              "assistant-busy": _vm.expandAssistantOverlayBusy,
              "assistant-message": _vm.expandAssistantOverlayMessage,
              "ai-assistant-open": _vm.aiAssistantOpen,
            },
            on: {
              close: _vm.closeExpandGraph,
              "patch-filters": _vm.onExpandFiltersPatch,
              "patch-controls": _vm.onExpandControlsPatch,
              "toggle-novelty": _vm.onExpandToggleNovelty,
              expand: _vm.runExpandGraph,
              "add-manual-node": _vm.onExpandManualAddNode,
              "intent-add-nodes": _vm.onExpandIntentAddNodes,
              "manual-add-error": _vm.onExpandManualAddError,
              "remove-history-entry": _vm.onRemoveExpansionHistoryEntry,
            },
          }),
          _c("WorkspaceAiAssistantPanel", {
            ref: "aiAssistantPanel",
            attrs: {
              open: _vm.aiAssistantOpen,
              planning: _vm.assistantPlanning,
              executing: _vm.assistantExecuting,
              "executing-step-label": _vm.assistantExecutingStepLabel,
              plan: _vm.assistantPlan,
              clarification: _vm.assistantClarification,
              "step-states": _vm.assistantStepStates,
              error: _vm.assistantError,
              "graph-nodes": _vm.assistantSuggestNodes,
            },
            on: {
              close: _vm.closeAiAssistant,
              "plan-request": _vm.onAssistantPlanRequest,
              "execute-all": _vm.onAssistantExecuteAll,
              "execute-step": _vm.onAssistantExecuteStep,
              "open-panel": _vm.onAssistantOpenPanel,
              "run-alternative": _vm.onAssistantRunAlternative,
              "error-acknowledged": function ($event) {
                _vm.assistantError = ""
              },
            },
          }),
          _c("WorkspaceVisibilityFilterPanel", {
            attrs: {
              open: _vm.filterGraphOpen,
              "ai-assistant-open": _vm.aiAssistantOpen,
              loading: _vm.graphFilterLoading,
              "progress-label": _vm.graphFilterProgress,
              filters: _vm.graphFilters,
              "saved-filters": _vm.savedVisibilityFilters,
              "expression-options": _vm.expressionOptions,
              "llm-available": _vm.llmAvailable,
              "filter-needs-llm": _vm.graphFilterNeedsLlm,
              "can-clear-draft": _vm.graphFilterCanClearDraft,
              "can-build": _vm.graphFilterCanBuild,
              "node-count": _vm.allGraphNodeCount,
              "visible-node-count": _vm.visibleGraphNodeCount,
              "invisible-node-count": _vm.invisibleGraphNodeCount,
            },
            on: {
              close: _vm.closeFilterGraph,
              "patch-filters": _vm.onGraphFiltersPatch,
              "toggle-novelty": _vm.onGraphFilterToggleNovelty,
              build: _vm.buildVisibilityFilter,
              "clear-draft": _vm.clearGraphFilterDraft,
              "toggle-filter": _vm.onToggleVisibilityFilterLayer,
              "remove-filter": _vm.onRemoveVisibilityFilterLayer,
              "remove-invisible-nodes": _vm.onRemoveInvisibleNodesFromGraph,
            },
          }),
        ],
        1
      ),
      _c("WorkspaceNodeActionMenu", {
        attrs: {
          open: Boolean(_vm.nodeActionMenu),
          node: _vm.nodeActionMenu,
          left: _vm.nodeActionMenu ? _vm.nodeActionMenu.left : 0,
          top: _vm.nodeActionMenu ? _vm.nodeActionMenu.top : 0,
          "can-remove": _vm.nodeActionMenu
            ? _vm.canRemoveGraphNode(
                _vm.activeSession,
                _vm.nodeActionMenu.nodeId
              )
            : false,
          "is-key-node": _vm.nodeActionMenu
            ? _vm.checkKeyNode(_vm.activeSession, _vm.nodeActionMenu.nodeId)
            : false,
        },
        on: {
          close: _vm.closeNodeActionMenu,
          inspect: _vm.onNodeActionInspect,
          "remove-node": _vm.onNodeActionRemove,
          expand: _vm.onNodeActionExpand,
          "select-connected": _vm.onNodeActionSelectConnected,
          "toggle-key-node": _vm.onNodeActionToggleKeyNode,
        },
      }),
      _c("WorkspaceEdgeActionMenu", {
        attrs: {
          open: Boolean(_vm.edgeActionMenu),
          edge: _vm.edgeActionMenu,
          left: _vm.edgeActionMenu ? _vm.edgeActionMenu.left : 0,
          top: _vm.edgeActionMenu ? _vm.edgeActionMenu.top : 0,
        },
        on: {
          close: _vm.closeEdgeActionMenu,
          inspect: _vm.onEdgeActionInspect,
          expand: _vm.onEdgeActionExpand,
        },
      }),
      _c("WorkspaceRemoveNodeConfirmModal", {
        attrs: {
          open: Boolean(_vm.pendingRemoveNode),
          "node-label": _vm.pendingRemoveNodeLabel,
          "edge-count": _vm.pendingRemoveEdgeCount,
        },
        on: { close: _vm.cancelRemoveNode, confirm: _vm.confirmRemoveNode },
      }),
      _c("WorkspaceLibraryModal", {
        attrs: {
          open: _vm.libraryOpen,
          records: _vm.savedGraphs,
          "graph-store": _vm.graphStore,
        },
        on: {
          close: _vm.closeLibrary,
          load: _vm.onLibraryLoad,
          duplicate: _vm.onLibraryDuplicate,
          delete: _vm.onLibraryDelete,
          exported: _vm.onLibraryExported,
          imported: _vm.onLibraryImported,
        },
      }),
      _c("WorkspaceDocumentationModal", {
        attrs: { open: _vm.docsOpen },
        on: { close: _vm.closeDocumentation },
      }),
      _c("WorkspaceWelcomeModal", {
        attrs: {
          open: _vm.welcomeOpen,
          "initial-tab": _vm.welcomeInitialTab,
          dismissible: _vm.canDismissWelcome,
          "has-saved-graphs": _vm.savedGraphs.length > 0,
          "show-learn-companion": _vm.showWelcomeLearnCompanion,
          "canvas-open-count": _vm.canvasOpenCount,
          "learn-companion-max-opens": _vm.learnCompanionMaxOpens,
        },
        on: {
          create: _vm.onWelcomeCreate,
          "create-with-assistant": _vm.onWelcomeCreateWithAssistant,
          "blank-canvas": _vm.onWelcomeBlankCanvas,
          "load-library": _vm.onWelcomeLoadLibrary,
          "import-graph": _vm.onWelcomeImportGraph,
          close: _vm.closeWelcome,
        },
      }),
      _c("WorkspaceLearnCompanionOverlay", {
        attrs: {
          open: _vm.learnCompanionOpen,
          "canvas-open-count": _vm.canvasOpenCount,
          "learn-companion-max-opens": _vm.learnCompanionMaxOpens,
          dismissible: _vm.canDismissWelcome,
        },
        on: { close: _vm.closeLearnCompanion },
      }),
      _c("WorkspaceInitialGraphModal", {
        attrs: {
          open: _vm.initialGraphOpen,
          buckets: _vm.starterBuckets,
          context: _vm.starterContext,
          "add-neighboring-nodes": _vm.addNeighboringNodes,
          "api-client": _vm.apiClient,
          "llm-available": _vm.llmAvailable,
          "gene-set-semantic-search-available":
            _vm.geneSetSemanticSearchAvailable,
          "duplicate-source-label": _vm.duplicateSourceLabel,
        },
        on: {
          "update:buckets": function ($event) {
            _vm.starterBuckets = $event
          },
          "update:context": function ($event) {
            _vm.starterContext = $event
          },
          "update:addNeighboringNodes": function ($event) {
            _vm.addNeighboringNodes = $event
          },
          reset: _vm.resetStarterBuilder,
          close: _vm.closeInitialGraph,
          continue: _vm.onInitialGraphContinue,
        },
      }),
      _c("WorkspaceSaveGraphModal", {
        attrs: {
          open: _vm.saveGraphOpen,
          label: _vm.saveGraphLabel,
          summary: _vm.graphSummary,
          "is-update": Boolean(_vm.loadedSavedGraphId),
          "completion-message": _vm.saveGraphCompletionMessage,
        },
        on: { close: _vm.closeSaveGraph, save: _vm.onSaveGraphConfirm },
      }),
      _c("WorkspaceExportGraphModal", {
        attrs: {
          open: _vm.exportGraphOpen,
          "default-filename": _vm.exportGraphDefaultFilename,
          summary: _vm.graphSummary,
          exporting: _vm.exportGraphBusy,
        },
        on: { close: _vm.closeExportGraph, export: _vm.onExportGraphConfirm },
      }),
      _c("WorkspaceExplainGraphModal", {
        attrs: {
          open: _vm.explainGraphOpen,
          entry: _vm.activeGraphInterpretation,
          scope: _vm.explainScope,
          "helper-text": _vm.explainHelperText,
          loading: _vm.graphInterpretationLoading,
          "llm-available": _vm.llmAvailable,
          "key-node-count": _vm.explainKeyNodeCount,
          "node-count": _vm.explainNodeCount,
          "edge-count": _vm.explainEdgeCount,
          "contextual-edge-count": _vm.explainContextualEdgeCount,
          "key-node-ids": _vm.canvasKeyNodeIds,
        },
        on: {
          close: _vm.closeExplainGraph,
          "update:scope": _vm.onExplainScopeChange,
          "update-entry": _vm.onExplainEntryPatch,
          run: _vm.runGraphExplanation,
          "add-suggested-key-node": _vm.onExplainAddSuggestedKeyNode,
          "add-all-suggested-key-nodes": _vm.onExplainAddAllSuggestedKeyNodes,
        },
      }),
      _c("WorkspaceBuildHypothesesModal", {
        attrs: {
          open: _vm.hypothesesOpen,
          "draft-run": _vm.activeSigChainDraft,
          "result-run": _vm.activeSigChainResult,
          loading: _vm.sigChainLoading,
          "llm-available": _vm.llmAvailable,
          "selected-node-count": _vm.explainKeyNodeCount,
          "selected-node-ids": _vm.canvasKeyNodeIds,
          "anchor-items": _vm.canvasAnchorItems,
          "session-context": _vm.activeSession
            ? _vm.activeSession.context || ""
            : "",
          "api-client": _vm.apiClient,
        },
        on: {
          close: _vm.closeBuildHypotheses,
          "update-draft": _vm.onSigChainDraftPatch,
          run: _vm.runSigChainPrioritization,
          "new-run": _vm.onSigChainNewRun,
          "pathway-state-update": _vm.onSigChainPathwayStateUpdate,
        },
      }),
      _c("WorkspaceFindRelatedDatasetsModal", {
        attrs: {
          open: _vm.relatedDatasetsOpen,
          "result-run": _vm.activeDatasetResult,
          "show-search-form": _vm.datasetShowSearchForm,
          loading: _vm.datasetLoading,
          "selected-gene-count": _vm.selectedGeneCount,
          "current-active-set-key": _vm.cfdeActiveSetKey,
          "canvas-graph-node-ids": _vm.canvasGraphNodeIds,
          "graph-busy": _vm.graphLoading,
        },
        on: {
          close: _vm.closeFindRelatedDatasets,
          search: _vm.runCfdeDatasetSearch,
          "search-again": _vm.onDatasetSearchAgain,
          "add-gene-set": _vm.onAddCfdeGeneSet,
          "remove-gene-set": _vm.onRemoveCfdeGeneSet,
        },
      }),
      _c("WorkspaceMapGenesModal", {
        attrs: {
          open: _vm.mapGenesOpen,
          loading: _vm.mapGenesLoading,
          error: _vm.mapGenesError,
          "selected-gene-set-count": _vm.selectedGeneSetCount,
          columns: _vm.mapGenesColumns,
          rows: _vm.mapGenesRows,
          "skipped-gene-sets": _vm.mapGenesSkippedGeneSets,
          "graph-gene-ids": _vm.canvasGraphNodeIds,
          "adding-gene": _vm.mapGenesAddingGene,
        },
        on: { close: _vm.closeMapGenes, "add-gene": _vm.onMapGenesAddGene },
      }),
      _c("WorkspaceProvenanceExplorerModal", {
        attrs: {
          open: _vm.provenanceExplorerOpen,
          "gene-set-nodes": _vm.selectedGeneSetGraphNodes,
        },
        on: {
          close: _vm.closeProvenanceExplorer,
          "open-explorer": _vm.onProvenanceExplorerOpened,
        },
      }),
      _c("input", {
        ref: "graphImportFileInput",
        staticClass: "rkw-graph-import-input",
        attrs: { type: "file", accept: ".json,application/json" },
        on: { change: _vm.onGraphImportFileChange },
      }),
      _c("transition", { attrs: { name: "rkw-fade" } }, [
        _vm.lastActionLabel
          ? _c("div", { staticClass: "rkw-action-status" }, [
              _vm._v(" " + _vm._s(_vm.lastActionLabel) + " "),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }